<template>
   <router-view />
</template>

<script>
// import { mapGetters } from 'vuex'

export default {
  name: 'app',

  // computed: mapGetters('drizzle', ['isDrizzleInitialized'])
}
</script>